import React from 'react';

import * as styles from './ChocolateSticker.styles';

export interface ChocolateStickerProps {
  content: string;
}

export const ChocolateSticker = ({ content }: ChocolateStickerProps) => {
  return (
    <div css={styles.container}>
      <img
        src="https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/blt006f1178eaeedc95/yellow_chocolate.png"
        alt={content}
      />
    </div>
  );
};
